export default "__VITE_ASSET__36a19967__"